<a [class]="linkStyle" [routerLink]="link" [target]="target">
  <span class="icon">
    <ng-content select="[icon]"></ng-content>
  </span>
  <span><ng-content></ng-content> </span>
</a>
